import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const MarketingTwo = (alt) => {
    const data = useStaticQuery(graphql`
    query {
      mockOne: file(relativePath: { eq: "scales-marketing-2.png" }) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)




    return <Img fluid={data.mockOne.childImageSharp.fluid} alt={alt} />
}

export default MarketingTwo
